var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialogTotal"},[_c('el-form',{ref:"form",staticClass:"formMsg",attrs:{"label-width":"45%","disabled":_vm.disabled}},[_c('total-form',{attrs:{"formItem":_vm.total}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41f1cfdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/exportData/dialogTotal.vue
// module id = null
// module chunks = 